import React from 'react'
import { Button, Col, Row, Space } from 'antd'
import { RefetchProps } from '../../../util/providers/CustomerProvider';

export type ActionsPanelProps = {
  loading: boolean;
  clearFilters: () => void;
  download: () => void;
  refetch: (props: RefetchProps) => void;
}

const ActionsPanel: React.FC<ActionsPanelProps> = ({loading, clearFilters, download, refetch}) => {
  return (
    <Row gutter={24}>
      <Col xs={24} sm={24}>
        <Row justify='end'>
          <div className="mr-auto" />
          <Space>
            <Button
              type="default"
              onClick={() => refetch({clearData: true})}
              loading={loading}
            >
              Reload
            </Button>
            <Button
              type="ghost"
              onClick={() => clearFilters()}
              disabled={loading}
            >
              Clear filters
            </Button>
            <Button
              type="default"
              onClick={() => download()}
              disabled={loading}
            >
              Download
            </Button>
          </Space>
        </Row>
      </Col>
    </Row>
  )
}

export default ActionsPanel
